<template>
  <v-dialog v-model="dialog" max-width="600">
    <template v-slot:activator="{ on, csModal }">
      <v-btn
        x-large
        elevation="3"
        class="ma-2"
        color="primary"
        v-bind="csModal"
        v-on="on"
        >Click Me</v-btn
      >
    </template>
    <v-card elevation="3" class="modal-card">
      <v-card-title>
        <h3>Project Overview</h3>
        <v-spacer></v-spacer>
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <hr />
      </v-card-title>
      <div class="modal-img">
        <img
          src="@/assets/images/featured-projects/Circuit-Studios.jpg"
          alt="SDP"
        />
      </div>
      <div class="project-info">
        <h1>Circuit Studios</h1>
        <p>
          Circuit Studios responsive website. Circuit Studios is a new cyclorama
          production stage operated by established production professionals. Our
          team consists of experienced technicians in all aspects of the
          production process. For the last several decades we have worked on
          productions ranging from major motion pictures and national commercial
          spots to reality and corporate television. Our studio provides a
          cyclorama stage with grid and a wide range of camera support and
          lighting gear to build your ideas. Circuit Studios provides services
          from: producing, direction, cinematography, still shoots, sound
          recording, grip and electric, (including a 3 ton grip truck), art
          direction, stunts, special effects, makeup, hair, post production and
          many others.
        </p>
        <ul class="details">
          <li><label>Client:</label>Circuit Studios</li>
          <li><label>Category:</label>Web Development</li>
          <li><label>Role:</label>Developer</li>
          <li>
            <label>Project URL:</label
            ><a target="_blank" href="http://www.circuitstudios.com/"
              >CircuitStudios.com</a
            >
          </li>
        </ul>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
    };
  },
};
</script>

<style lang="scss">
</style>